import React from "react";
import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import logoImage from "../../assets/images/game-supergirls/logo-big.webp";
import characterImage from "../../assets/images/game-supergirls/Sticker-OK.png";

const QuizScreen = ({
  question,
  onAnswer,
  onSubmit,
  selectedOptionId,
  isLastQuestion,
  currentIndex,
  totalQuestions,
}) => {
  if (!question) return <div>กำลังโหลด...</div>;

  // 🔥 สร้าง options ใหม่จากโครงสร้าง backend
  const options = [
    { id: "a", text: question.option_a },
    { id: "b", text: question.option_b },
    { id: "c", text: question.option_c },
    { id: "d", text: question.option_d },
  ];

  return (
    <div className="quiz-container">
      <img
        src={headerImage}
        alt="ตามหารักที่เธอลืม"
        className="quiz-header-image"
      />

      <div className="quiz-title-section">
        <img src={logoImage} alt="Big C" className="quiz-logo" />
        <h2>
          เกมตอบคำถาม
          <br />
          ลุ้นพอยต์
        </h2>
      </div>

      <div className="question-card-wrapper">
        <div className="question-card">
          <h3>{question.question_text}</h3>

          <div className="options-grid">
            {options.map((option, index) => (
              <button
                key={option.id}
                className={`option-button ${
                  selectedOptionId === option.id ? "selected" : ""
                }`}
                onClick={() => onAnswer(option.id)} // ✔ ส่ง option id (a,b,c,d)
              >
                <span>{index + 1}.</span> {option.text}
              </button>
            ))}
          </div>
        </div>
      </div>

      <img
        src={characterImage}
        alt="Character"
        className="character-popout-image"
      />

      <button
        className={`submit-button ${
          selectedOptionId ? "submit-button-active" : "submit-button-inactive"
        }`}
        onClick={onSubmit}
        disabled={!selectedOptionId}
      >
        {isLastQuestion ? "ตอบเลย!" : "คำถามต่อไป"}
      </button>

    </div>
  );
};

export default QuizScreen;
